import React from "react";

export const AutoResizeTextarea = React.forwardRef((props, ref) => {
	const { onChange, ...other } = props;
	const textareaRef = React.useRef();

	React.useEffect(() => {
		if (textareaRef.current) {
			textareaRef.current.style.height = "auto";
			textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
		}
	}, [props.value]);

	const handleChange = (event) => {
		if (onChange) {
			onChange(event);
		}
		setTimeout(() => {
			if (textareaRef.current) {
				textareaRef.current.style.height = "auto";
				textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
			}
		}, 0);
	};

	return (
		<textarea
			{...other}
			ref={(el) => {
				textareaRef.current = el;
				if (ref) {
					if (typeof ref === "function") {
						ref(el);
					} else {
						ref.current = el;
					}
				}
			}}
			onChange={handleChange}
			style={{
				...other.style,
				minHeight: "20px",
				resize: "none",
				overflow: "hidden"
			}}
		/>
	);
});
